<template>
  <div class="flex flex-col items-center bg-white rounded shadow-lg p-4">
    <!-- crm logo -->
    <img src="@/assets/icons/mailing.png" class="w-32 mb-3 mt-5" />

    <!-- Description -->
    <div class="mt-2" v-html="$t('integrations.mailing.guide')" />

    <!-- Add input Avatar -->
    <div
      class="flex justify-center rounded-full transition duration-500 ease-in-out h-12 w-12 p-3 border-2 cursor-pointer mt-5 mb-5"
      @click="addInput"
    >
      <font-awesome-icon icon="plus" size="lg" color="grey" />
    </div>

    <!-- Input List -->
    <div class="flex flex-row flex-wrap justify-center">
      <div v-for="(input, i) in inputLines" :key="i" class="flex flex-row p-1">
        <!-- email input instance -->
        <r-text-field
          v-model="input.value"
          validation="email"
          id="email-list-input"
          class="w-50 mb-4"
          style="width: 200px"
        />
        <!-- Remove input line -->
        <font-awesome-icon
          v-if="inputLines.length > 1"
          icon="minus"
          color="grey"
          class="mt-2 ml-1 cursor-pointer"
          @click="removeInput(i)"
        />
      </div>
    </div>
    <!-- Buttons -->
    <div class="w-full h-full flex items-end justify-end">
      <!-- Close button -->
      <r-button class="h-10 mr-2" color="black" text @click="closeEmails">
        {{ $t("buttons.close") }}
      </r-button>

      <!-- Save button -->
      <r-button
        class="h-10"
        :loading="loading"
        @click="sumbitEmails"
        :disabled="isSaveEmailDisable"
      >
        {{ $t("buttons.save") }}
      </r-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { validateEmail } from "../../utils"

export default {
  // local state
  data() {
    return {
      loading: false,
      inputLines: [
        {
          value: ""
        }
      ]
    }
  },

  // props
  props: {
    mode: {
      type: String,
      default: ""
    }
  },

  // set watch
  watch: {
    mode: {
      immediate: true,
      handler() {
        // update current input lines
        if (this.mode === "edit") {
          // pull org id
          const orgId = this.userDoc.orgs[0]

          // pull emails values from current user doc
          const emailsValues =
            ((this.userDoc.mailing || {})[orgId] || {}).values || []

          // set the inputLines with user's current emails
          this.inputLines = emailsValues.map((emailVal) => ({
            value: emailVal
          }))
        }
      }
    }
  },

  // computed propetires
  computed: {
    ...mapGetters({
      // userdoc attribute
      userDoc: "users/getDoc"
    }),

    /**
     * isSaveEmailDisable returns true if
     * save emails button should be disabled
     */
    isSaveEmailDisable() {
      // find from all inputs one value that is not
      // an email
      const nonEmailValue = this.inputLines.find((input) => {
        return !validateEmail(input.value)
      })

      // returns true if found value
      return Boolean(Object.keys(nonEmailValue || {}).length)
    },

    /**
     * formattedEmailsList gets the values from
     * the current input lines
     */
    formattedEmailsList() {
      return this.inputLines.map((input) => input.value || "")
    }
  },

  // handle notification
  notifications: {
    notifyError: {
      type: "error"
    }
  },

  // methods
  methods: {
    /**
     * Remove input from input lines
     */
    removeInput(i) {
      this.inputLines = this.inputLines.filter((input, index) => {
        return index !== i
      })
    },

    /**
     * Add input to inputlines
     */
    addInput() {
      this.inputLines.push({
        value: ""
      })
    },

    /**
     * Submit emails
     */
    async sumbitEmails() {
      try {
        // set loader
        this.loading = true

        // pull user's org id
        const orgId = this.userDoc.orgs[0]

        // update users record
        await this.$store.dispatch("users/update", {
          id: this.userDoc.id,
          options: {
            ignore_flatten: true
          },
          data: {
            mailing: {
              [orgId]: {
                values: this.formattedEmailsList || []
              }
            }
          }
        })
      } catch (e) {
        console.error(e)
        this.notifyError({
          title: this.$t("errors.unableToEnableMailing"),
          message: e.message
        })
      }

      // close input
      this.$emit("close")

      // set loading false
      this.loading = false
    },

    /**
     * Close emails dialog
     */
    closeEmails() {
      this.$emit("close")
    },

    /**
     * resetEmails reset the list of emails
     */
    resetEmails() {
      this.inputLines = [
        {
          value: ""
        }
      ]
    }
  }
}
</script>
